<apm-section-title
  *ngIf="props.label"
  [title]="props.label | apmTranslate"
  [ngClass]="{ 'mt-4': !isFirst }"
  [alignContentEnd]="false"
  matTooltip="{{ canDebug ? field.key : '' }}"
>
  <ng-container *ngIf="props.errorsResource?.length > 0">
    <span class="ms-3"></span>
    <apm-icon
      class="me-2"
      size="sm"
      [isButton]="true"
      (iconClick)="showErrorMessages(props.errorsResource)"
      icon="i_alert_error"
    ></apm-icon>
  </ng-container>
</apm-section-title>
<div class="mb-2 overflow-x-auto">
  <table>
    <thead>
      <tr>
        <th class="text bold min-w-md bg-light-gray3"></th>
        <th
          class="text-center bg-light-gray3 cursor-pointer formly-table-wrapper-value-cell"
          *ngFor="let col of tableColumns"
          (click)="onColumnClick(col)"
          matTooltip="{{ col.tooltipResourceId ? (col.tooltipResourceId | apmTranslate) : '' }}"
        >
          <span class="text bold">{{ col.label }}</span>
        </th>
      </tr>
    </thead>
    <tr
      *ngFor="let row of field.fieldGroup"
      [ngClass]="{
        'bg-certified-row--green': row.props?.flags === 1,
        'bg-certified-row--ligth-green': row.props?.flags === 3,
        'bg-certified-row--orange': row.props?.flags === 4,
      }"
    >
      <td class="text bold min-w-md formly-table-wrapper-value-cell">
        <span matTooltip="{{ canDebug ? row.key : '' }}">{{
          row.props?.label ? (row.props?.label | apmTranslate) : '-'
        }}</span>
      </td>
      <td class="text-center" *ngFor="let col of tableColumns">
        <apm-table-wrapper-cell [value]="row.props?.rowData[col.field]" [props]="row.props"></apm-table-wrapper-cell>
      </td>
    </tr>
  </table>
  <div class="fw-bold text-center mt-2" *ngIf="field.fieldGroup?.length === 0">
    {{ 444721 | apmTranslate }}
  </div>
</div>
